import { Button, type Column, EmptyState, Pill, Table } from "@/components/common";
import type { SessionResponse } from "@/types/session";
import { useRevokeOtherSessions, useRevokeSession, useSessions } from "@/hooks/useSessions";
import { formatDate } from "@/utils/fmt";

/** Active-sessions table with per-device revoke — embeddable (no PageHead). */
export function SessionsList() {
  const { data: sessions = [], isLoading } = useSessions();
  const revoke = useRevokeSession();
  const revokeOthers = useRevokeOtherSessions();

  const columns: Column<SessionResponse>[] = [
    {
      id: "device",
      header: "Dispositivo",
      cell: (s) => (
        <div className="emp-table-name">
          <div>
            <div className="razao">{s.device_id ?? "Navegador"}</div>
            <div className="fantasia">{s.user_agent.slice(0, 48)}</div>
          </div>
        </div>
      ),
    },
    { id: "ip", header: "IP", cell: (s) => <span className="td-small">{s.ip}</span> },
    { id: "last", header: "Última atividade", cell: (s) => formatDate(s.last_used_at) },
    {
      id: "current",
      header: "",
      cell: (s) => (s.is_current ? <Pill tone="ativa">Atual</Pill> : null),
    },
  ];

  return (
    <div className="sessions-list">
      <div className="sessions-list-head">
        <span className="td-small">{sessions.length} dispositivo(s)</span>
        <Button
          variant="ghost"
          size="sm"
          iconLeft="log-out"
          onClick={() => revokeOthers.mutate()}
          disabled={revokeOthers.isPending || sessions.length <= 1}
        >
          Encerrar outras
        </Button>
      </div>
      <Table
        rows={sessions}
        columns={columns}
        getKey={(s) => String(s.id)}
        density="compact"
        rowAction={(s) =>
          s.is_current ? null : (
            <Button
              variant="outline"
              size="sm"
              onClick={() => revoke.mutate(s.id)}
              disabled={revoke.isPending}
            >
              Encerrar
            </Button>
          )
        }
        empty={<EmptyState icon="shield-check" title={isLoading ? "Carregando…" : "Nenhuma sessão"} />}
      />
    </div>
  );
}
